<template>
  <span>
      <a-tag v-if="record.victoryType !== null">
        <span v-if="record.victoryType === 'DRAW'"><b style="color:red;">{{ record.victoryXs }}</b></span>
        <span v-else>
          <b v-if="record.victoryType === 'BLUE'" style="color:rgb(18, 146, 193);">{{ programVictoryXs.getColor(record.programId).blue }}方</b>
          <b v-else style="color:rgb(180, 16, 0);">{{ programVictoryXs.getColor(record.programId).red }}方</b>
          <b style="color:red;"> {{ record.victoryXs }} </b>
          <b v-if="programId === 4 || programId === 5">{{ record.blueScore }}:{{ record.redScore }}<span v-if="record.blueKick || record.redKick">({{ record.blueKick }}:{{ record.redKick }})</span></b>
          <b v-else>{{ record.blueScore }}:{{ record.redScore }}</b>
        </span>
      </a-tag>
      <a-tag v-else color="#cccccc">暂未判胜</a-tag>
  </span>
</template>

<script>
import programVictoryXs from '@comm/utils/programVictoryXs'
export default {
  name: 'ResultTag',
  components: {
  },
  data () {
    return {
      programVictoryXs: programVictoryXs,
      programId: Number(this.$route.query.programId),
    }
  },
  props: {
    record: {
      type: Object
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/ResultPkTag.vue